import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, type ReactElement, type ReactNode } from 'react';
import { type CopilotSurface } from 'shared/copilot/copilotSurfaces';
const CopilotSurfaceContext = createContext<CopilotSurface>('drawer');

/**
 * Scopes which Copilot conversation {@link useCopilot} resolves for message
 * APIs (drawer vs fullscreen). Shared shell fields are always available.
 */
export const CopilotSurfaceProvider = t0 => {
  const $ = _c(3);
  const {
    surface,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== surface) {
    t1 = <CopilotSurfaceContext.Provider value={surface}>{children}</CopilotSurfaceContext.Provider>;
    $[0] = children;
    $[1] = surface;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useCopilotSurface = () => {
  return useContext(CopilotSurfaceContext);
};